import { createTransform, persistReducer } from 'redux-persist';
import storage from 'redux-persist/es/storage';
import { uptimeApi } from 'core/api';
import rootReducer from './reducers';

// `isSorting` is transient edit-mode state on the dashboard slice: it is set only by an
// actual widget drag (onSortEnd) and gates the reorder request. Persisting it lets a stale
// `true` (e.g. from a tab closed mid-edit) rehydrate on the next load and fire a spurious
// `PUT dashboard/company-widgets/reorder` when no drag happened this session. Strip it on both
// write and rehydrate so it can only ever be `true` because of a drag in the current session.
type DashboardSliceState = {
  default?: { isSorting?: boolean } & Record<string, unknown>;
} & Record<string, unknown>;

const stripDashboardTransientState = (state: DashboardSliceState) => {
  if (!state?.default || !('isSorting' in state.default)) {
    return state;
  }
  const { isSorting, ...rest } = state.default;
  return { ...state, default: rest };
};

const dashboardTransientTransform = createTransform(
  stripDashboardTransientState,
  stripDashboardTransientState,
  { whitelist: ['dashboard'] }
);

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  blacklist: [uptimeApi.reducerPath, 'remoteConfig', 'map'],
  transforms: [dashboardTransientTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
